import React, { useCallback, useState } from "react";
import { copiarAlPortapapeles } from "../../helpers/portapapeles";
import { OrgToast } from "./TurnosUi";

/* Link de reservas del profesional vinculado: `bookingUrl` del back o, si falta, se arma con el slug del salón y el del profesional. */
export const urlDeReservas = (professional, salon) => {
  if (professional?.bookingUrl) return professional.bookingUrl;
  if (!professional?.slug) return "";
  const salonRef = salon?.slug || salon?._id;
  if (!salonRef) return "";
  return `${window.location.origin}/beauty/${salonRef}/${professional.slug}`;
};

/* Card "Tu link de reservas": URL de solo lectura, copiar y compartir por WhatsApp. Sin URL no se muestra. */
const TuLinkDeReservas = ({ professional, salon }) => {
  const [toast, setToast] = useState("");
  const cerrarToast = useCallback(() => setToast(""), []);
  const url = urlDeReservas(professional, salon);
  if (!url) return null;

  const copiar = async () => {
    try {
      await copiarAlPortapapeles(url);
      setToast("Link copiado al portapapeles.");
    } catch (_) {
      setToast("No se pudo copiar el link.");
    }
  };
  const mensaje = `Reservá tu turno conmigo acá: ${url}`;

  return (
    <section className="zr-panel zr-milink" aria-labelledby="zr-milink-titulo">
      <h2 id="zr-milink-titulo" className="zr-milink__title">Tu link de reservas</h2>
      <p className="zr-milink__text">
        Compartilo con tus clientes: los turnos que reserven desde acá ya vienen asignados a vos.
      </p>
      <label className="zr-milink__field">
        <span>Link</span>
        <input type="text" readOnly value={url} onFocus={(e) => e.target.select()} />
      </label>
      <div className="zr-milink__actions">
        <button type="button" className="zr-btn zr-btn--dark" onClick={copiar}>Copiar link</button>
        <a
          className="zr-btn zr-btn--soft"
          href={`https://wa.me/?text=${encodeURIComponent(mensaje)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Enviar por WhatsApp
        </a>
      </div>
      <OrgToast message={toast} onClose={cerrarToast} />
    </section>
  );
};

export default TuLinkDeReservas;
